module.exports = __webpack_public_path__ + "static/bite-sized-lessons-5b45ea8178aad235a6dedfc44c366a9a.webp";